import React from 'react';
import { Segment, Container, Header, Table, Dimmer, Label, Loader, Breadcrumb, Icon,Menu, Checkbox, Button, Input, Pagination} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import UsuarioCursoRow from './UsuarioCursoRow';


const UsuarioCursoList=({usuariocurso, ajaxCallInProgress, onShowModalActivar, onShowModalBorrar, activePage, totalPages, handleSelectPagination , color, form, permisos, showActivos, handleChangeActivos, handleChangeFiltro, filtro, onFiltrarInformacion, filtroActual, filtroActivo, onDesactivarFiltro, strings, usuarioActual})=>{

    return (
        <Container>
         <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
            <Loader size='big' inline content={strings?strings["Procesando"]:""}/>
        </Dimmer>
        <Header  dividing>
            <Header.Content>{strings?strings["UsuarioCurso"]:""}</Header.Content>
          </Header>
            <Menu  stackable   >
                <Menu.Item>
                      <Header>
                        <Header.Content>{strings?strings["acciones"]:""}:</Header.Content>
                      </Header>
                </Menu.Item>
                <Menu.Item>
                    <Link to="/usuariocurso">
                      <Button    animated='fade'>
                          <Button.Content visible>{strings?strings["nuevo"]:""}</Button.Content>
                          <Button.Content hidden > <Icon name='plus' /> </Button.Content>
                        </Button>
                    </Link>
                </Menu.Item>
                
                <Menu.Item >
                   <Checkbox slider size="mini" checked={showActivos}  onClick={handleChangeActivos} label={strings?strings["factivos"]:""}/>
                </Menu.Item>
                <Menu.Item position='right'>
                   <Input   onChange={handleChangeFiltro} value={filtro} 
                        action={{ type: 'button',  icon: 'search', onClick:onFiltrarInformacion}} 
                    placeholder={strings?strings["buscar"]:""} />
                </Menu.Item>
          </Menu>
           {filtroActivo?
                <Label link onClick={onDesactivarFiltro} color='yellow'  >
                        Filtro activo: {filtroActual} <Icon name='close' /> 
                      </Label>
            : ""}
                <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>    
                        <Table.HeaderCell>{strings?strings["descripcion"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["estatus"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["accion"]:""}</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {usuariocurso.map(renglon =>
								<UsuarioCursoRow 
                                   onShowModalActivar={onShowModalActivar}
									key={renglon.id} 
									usuariocurso={renglon} 	
                                   onShowModalBorrar={onShowModalBorrar}
									color={color}
									form={form}
									permisos={permisos}
									/>
				        )}	
                    </Table.Body>
                  </Table> 
         
    
        <Segment attached="bottom"   centered >
            <Pagination	totalPages={totalPages}
              				activePage={activePage}
							onPageChange={handleSelectPagination}
				/>
        </Segment>
        </Container>
	);
};



export default UsuarioCursoList;